
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip_desktop)"}},[_c('path',{attrs:{"d":"M23.412 2.188A1.926 1.926 0 0022 1.6H2c-.55 0-1.02.196-1.413.588A1.926 1.926 0 000 3.6v13.6c0 .55.196 1.02.587 1.413.392.391.863.587 1.413.587h6.8c0 .317-.067.642-.2.975a8.859 8.859 0 01-.4.875c-.133.25-.2.433-.2.55 0 .216.08.404.238.562a.768.768 0 00.562.238h6.4c.217 0 .404-.08.563-.238A.767.767 0 0016 21.6c0-.108-.067-.29-.2-.544a9.173 9.173 0 01-.4-.887c-.133-.338-.2-.66-.2-.969H22c.55 0 1.02-.196 1.412-.587.392-.392.588-.863.588-1.413V3.6c0-.55-.196-1.02-.588-1.412zM22.4 14c0 .108-.04.202-.119.281A.385.385 0 0122 14.4H2a.385.385 0 01-.281-.119.385.385 0 01-.119-.28V3.6c0-.11.04-.203.119-.282A.385.385 0 012 3.2h20c.108 0 .202.04.281.119.08.08.119.173.119.281V14z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip_desktop"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    